import { render, staticRenderFns } from "./EditBusinessInfo2.vue?vue&type=template&id=6af39af6&scoped=true"
import script from "./EditBusinessInfo2.vue?vue&type=script&lang=js"
export * from "./EditBusinessInfo2.vue?vue&type=script&lang=js"
import style0 from "./EditBusinessInfo2.vue?vue&type=style&index=0&id=6af39af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af39af6",
  null
  
)

export default component.exports